import React from "react";
import { Linkedin, Instagram, Twitter, Facebook } from "lucide-react";
import multify from "../assets/multify.webp";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { menuItems } from "../Content/HomeContent";

const Footer = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  return (
    <footer className="text-gray-300 py-16">
      <div className="container mx-auto">
        {/* Logo and Social Media Section */}
        <div className="flex justify-between items-center md:flex-row flex-col">
          <img
            src={multify}
            alt="Multify Logo"
            className="w-32  md:w-40 lg:w-48 xl:w-56"
          />
          <div className="flex items-center gap-4 md:flex-row flex-col">
            <span className="text-base">Follow Us On Social Media</span>{" "}
            {/* Added text-base for better readability */}
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com/company/multifysolutions" // Keep href for social media links
                className="bg-black p-2 rounded-full hover:bg-gray-900 transition-colors"
                target="_blank" // Open in new tab for social media
                rel="noopener noreferrer" // Security best practice
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://www.instagram.com/multify_solutions" // Keep href for social media links
                className="bg-black p-2 rounded-full hover:bg-gray-900 transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.facebook.com/multifysolutions/" // Keep href for social media links
                className="bg-black p-2 rounded-full hover:bg-gray-900 transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Rest of the footer content */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mb-12 mt-12 text-left">
          {menuItems.map((menu, index) => (
            <div key={index}>
              <h3 className="text-white font-semibold mb-4">{menu.title}</h3>
              <ul className="space-y-2 text-[#808080]">
                {menu.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <span
                      onClick={() => navigate(link.path)}
                      className="hover:text-white transition-colors cursor-pointer"
                    >
                      {link.label}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 pt-8 text-[#808080]">
          <div className="flex flex-col md:flex-row justify-between items-center relative">
            <div className="text-sm mb-4 md:mb-0">
              ©{new Date().getFullYear()} Multify Solutions Pvt. Ltd. All Rights
              Reserved.
            </div>
            {/* Centered Version Number */}
            <div className="absolute left-1/2 -translate-x-1/2 text-sm sm:black hidden">
              {" "}
              {/* Added text-sm */}
              <span>Version 1.0</span>
            </div>
            <div className="flex  items-center gap-4 text-sm ">
              <span
                onClick={() => navigate("/privacy-policy")}
                className="hover:text-white transition-colors cursor-pointer"
              >
                Privacy Policy
              </span>
              <span
                onClick={() => navigate("/terms")}
                className="hover:text-white transition-colors cursor-pointer"
              >
                Terms & Conditions
              </span>
              <span
                onClick={() => navigate("/cookie-policy")}
                className="hover:text-white transition-colors cursor-pointer"
              >
                Cookie Policy
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
